import { FormikErrors, useFormikContext } from "formik"
import React from "react"

import CustomerAutocomplete from "./customer"
import type { CreateReservationFormValues, CustomerFormData } from "./use_booking_state"

const CustomerSection: React.FC = () => {
  const { setFieldValue, touched, errors } = useFormikContext<CreateReservationFormValues>()

  const customerTouched = touched.customer
  const customerErrors = errors.customer as FormikErrors<CustomerFormData> | string | undefined

  return (
    <CustomerAutocomplete
      onChange={(data) => {
        void setFieldValue("customer", {
          name: data.name,
          email: data.email,
          phone: data.phone,
        })
      }}
      touched={
        customerTouched && typeof customerTouched === "object"
          ? {
              name: customerTouched.name,
              email: customerTouched.email,
              phone: customerTouched.phone,
            }
          : {}
      }
      errors={
        customerErrors && typeof customerErrors === "object"
          ? {
              name: customerErrors.name,
              email: customerErrors.email,
              phone: customerErrors.phone,
            }
          : {}
      }
    />
  )
}

export default CustomerSection
